import maska from "maska";
import "material-icons/iconfont/material-icons.css";
import { createPinia } from "pinia";
import "v-calendar/dist/style.css";
import { createApp } from "vue";
import toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import VueApexCharts from "vue3-apexcharts";

import App from "./App.vue";
import worker from "./mocks";
import { initializeSentry } from "./plugins/sentry";
import router from "./router";
import "./styles/global.postcss";
import { useLoadingStore } from "./store/loading";
import { handleAppError } from "./utils/error";

if (import.meta.env.VITE_ENVIRONMENT?.toString().toLowerCase() === "dev") {
  worker.start({ onUnhandledRequest: "bypass" });
}

const app = createApp(App) //
  .use(router)
  .use(createPinia())
  .use(maska)
  .use(toast)
  .use(VueApexCharts);

initializeSentry(app, router);

app.config.errorHandler = handleAppError;

router.beforeEach((to, from, next) => {
  const loadingStore = useLoadingStore();
  loadingStore.isRouteLoading = true;
  next();
});

router.afterEach(() => {
  const loadingStore = useLoadingStore();
  setTimeout(() => {
    loadingStore.isRouteLoading = false;
  }, 2000);
});

app.mount("#app");
